import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { TyreConfigPage } from '@/features/tyre-config/tyre-config-page';

/** The tyre hotel's "Stam data". The profile route itself requires `tyre-config:read`. */
export const Route = createFileRoute('/_app/tyre-config')({
  staticData: { featureKey: 'tyre-config' },
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, {
      feature: 'tyre-config',
      permissions: ['tyre-config:read'],
    }),
  component: TyreConfigPage,
});
